import React/* , { useState } */ from 'react';
import { Modal, Button, Carousel, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { getUploadsBaseUrl } from '../../../api/axiosInstance';

function ProductModal(props) {
    const { addProductToCart, onHide, isAdded, /* portalClosed, */ addToCartDisabled } = props;
    const { t } = useTranslation();
    
    const handleClick = () => {
        addProductToCart();
        onHide();
    }

    const { productsMaterials, bundledProducts } = props.product;

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('products.description')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3 style={{marginBottom:0}}>{props.product.name}</h3>
                    <p style={{marginBottom:15}}>
                        {props.product.sku && `| ${props.product.sku}`}
                    </p>
                    <p>
                      {props.product.description}  
                    </p>

                    {bundledProducts && bundledProducts.length ?
                        <div>   
                            <p>{t('products.bundled_products')}:</p>
                            <Table
                                striped
                                size="sm"
                            >
                                <thead>
                                    <tr>
                                        <th>{t('orders.product_name')}</th>
                                        <th>sku</th>
                                        <th>{t('orders.amount')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bundledProducts.map((product) => (
                                        <tr key={product.productBundleID}>
                                            <td>{product.name}</td>
                                            <td>{product.sku}</td>
                                            <td>{product.quantity}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    : null}
            
                    {productsMaterials && productsMaterials.length > 0 ?
                        <Carousel
                            controls={productsMaterials.length > 1}
                            indicators={false}
                            interval={null}
                            className="mb-3"
                        >
                            {productsMaterials.map(({ material }) => (
                                <Carousel.Item key={material.materialID}>
                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ width: '100%', height: 300 }}
                                        >
                                            <img
                                                style={{ maxWidth: '100%', maxHeight: '100%', cursor: 'zoom-in' }}
                                                src={`${getUploadsBaseUrl()}${material.absolutePath}_M`}
                                                alt="product slide"
                                                onClick={() => {
                                                    window.open(`${getUploadsBaseUrl()}${material.absolutePath}`, '_blank');
                                                }}
                                            />
                                        </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    : null}
                
                    <Button
                        className="float-right"
                        variant={isAdded ? 'danger' : 'primary'}
                        size="sm"
                        style={{cursor: props.product.stock !== 0 ? 'pointer' : 'no-drop'}}
                        disabled={addToCartDisabled}
                        onClick={handleClick}
                    >
                        {!isAdded ? t('products.add_to_cart') : t('products.remove_from_cart')}
                    </Button>
                    <p>
                        {props.vat ?
                            props.product.totalPriceRounded + ' € ('  + props.product.taxPercentRounded + ' %)'
                            :
                            props.product.priceRounded + ' € (0.00 %)'
                        }
                    </p>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button type="button" variant="default" onClick={() => props.onHide()}>Sulje</Button>
                </Modal.Footer> */}
            </div>
        </Modal>
    )
};

export default ProductModal;